import React from 'react'

const Manual_config_tipos_pago = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Configuraciones - Tipos de Pago
        </h2>
        <iframe
          src="https://scribehow.com/embed/Configuraciones__Tipos_de_Pago__ZC7xA8_9Tw2kXKVW_WjuAQ?as=scrollable"
          className="scribe-iframe-general-159"
          width="100%"
          height="5400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_config_tipos_pago
